import html2canvas from 'html2canvas'

export default {
  // dom截图转file对象
  async domToFile (el) {
    if (!el) {
      return
    }
    const width = el.offsetWidth
    const scale = 722.5 / width
    const options = {
      scale,
      backgroundColor: null,
    }
    const canvas = await html2canvas(el, options)
    return new Promise(reslove => {
      // document.querySelector('.down').setAttribute('href', canvas.toDataURL())
      canvas.toBlob(ret => {
        const file = new File([ret], 'radarchart', { lastModified: Date.now() })
        reslove(file)
      })
    })
  }
}